const ChevronFilledIcon = ({ className, ...props }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path d="M11.6464 14.6464L7.85355 10.8536C7.53857 10.5386 7.76165 10 8.20711 10H15.7929C16.2383 10 16.4614 10.5386 16.1464 10.8536L12.3536 14.6464C12.1583 14.8417 11.8417 14.8417 11.6464 14.6464Z" fill="currentColor"/>
    </svg>
)

export default ChevronFilledIcon